var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 17,
    viewBox: "0 0 263 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_394_4837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.845 17C119.718 17 118.617 16.8307 117.54 16.4921C114.034 15.404 111.655 12.7439 110.979 9.23753C110.178 5.05403 113.058 1.0398 117.39 0.265977C119.092 -0.0242076 120.82 0.314341 122.248 1.28162C123.675 2.22473 124.626 3.67565 124.952 5.32003C125.478 8.10097 123.55 10.7852 120.67 11.293C120.345 11.3414 120.044 11.1479 119.994 10.8335C119.944 10.5192 120.144 10.229 120.47 10.1806C122.723 9.79371 124.226 7.68987 123.8 5.51349C123.55 4.15929 122.748 2.97437 121.597 2.20054C120.42 1.42672 119.017 1.11235 117.615 1.37835C113.909 2.03127 111.455 5.46512 112.131 9.04407C112.707 12.1394 114.811 14.4609 117.891 15.4281C121.221 16.468 125.002 15.6458 127.531 13.3485C129.059 11.9459 129.885 10.1564 130.786 8.27024C131.563 6.65004 132.339 4.98148 133.616 3.55474C136.27 0.556162 140.602 -0.677124 144.609 0.362706C148.34 1.32999 150.969 4.11093 151.645 7.76242C152.021 9.79371 151.57 11.825 150.368 13.5178C149.166 15.2105 147.338 16.3471 145.235 16.7098C141.704 17.3385 138.324 15.0654 137.673 11.6557C137.147 8.8748 139.075 6.19059 141.954 5.68276C142.28 5.6344 142.58 5.82785 142.631 6.14222C142.681 6.45659 142.48 6.74677 142.155 6.79514C139.901 7.18205 138.399 9.28589 138.824 11.4623C139.35 14.2674 142.13 16.1052 145.034 15.5974C146.812 15.283 148.39 14.3158 149.416 12.8648C150.443 11.4139 150.844 9.6728 150.518 7.93169C149.892 4.66711 147.639 2.27309 144.308 1.40253C140.727 0.459434 136.871 1.57181 134.492 4.23184C133.341 5.53767 132.614 7.06114 131.838 8.68134C130.937 10.5917 130.01 12.5505 128.332 14.0981C126.304 16.0085 123.575 17 120.845 17Z",
    fill: "#00B2DD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.045 8.43952H151.996C151.67 8.43952 151.42 8.1977 151.42 7.88334C151.42 7.56897 151.67 7.32715 151.996 7.32715H260.045C260.371 7.32715 260.621 7.56897 260.621 7.88334C260.621 8.17352 260.371 8.43952 260.045 8.43952Z",
    fill: "#00B2DD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.729 8.43952H2.67932C2.3538 8.43952 2.10339 8.1977 2.10339 7.88334C2.10339 7.56897 2.3538 7.32715 2.67932 7.32715H110.729C111.054 7.32715 111.305 7.56897 111.305 7.88334C111.305 8.17352 111.054 8.43952 110.729 8.43952Z",
    fill: "#00B2DD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.42 11.5106C121.056 11.5106 121.571 11.0126 121.571 10.3983C121.571 9.78392 121.056 9.28589 120.42 9.28589C119.783 9.28589 119.268 9.78392 119.268 10.3983C119.268 11.0126 119.783 11.5106 120.42 11.5106Z",
    fill: "#00B2DD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.081 6.6258C143.081 7.25454 142.555 7.73818 141.929 7.73818C141.278 7.73818 140.777 7.23036 140.777 6.6258C140.777 5.99707 141.303 5.51343 141.929 5.51343C142.58 5.51343 143.081 6.02125 143.081 6.6258Z",
    fill: "#00B2DD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.321 10.4466C261.8 10.4466 263 9.28812 263 7.85909C263 6.43006 261.8 5.27161 260.321 5.27161C258.841 5.27161 257.641 6.43006 257.641 7.85909C257.641 9.28812 258.841 10.4466 260.321 10.4466Z",
    fill: "#00B2DD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67933 10.4466C4.15908 10.4466 5.35866 9.28812 5.35866 7.85909C5.35866 6.43006 4.15908 5.27161 2.67933 5.27161C1.19958 5.27161 0 6.43006 0 7.85909C0 9.28812 1.19958 10.4466 2.67933 10.4466Z",
    fill: "#00B2DD",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_394_4837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginDesign);
export default __webpack_public_path__ + "static/media/loginDesign.163b9b91cbcca5bbaee21c01840e7fd7.svg";
export { ForwardRef as ReactComponent };